module.exports = __webpack_public_path__ + "img/201.0d2f0124.png";